import request from '@/lib/request'


/***
 * 发送登录短信验证密码或语音验证码
 * @param params
 * @returns {Promise | Promise<unknown>}
 * @private
 */
export function getCode(params = {}) {
  return request.post('/api/v1/rental/common/code', {
    "mobile": params.mobile,
    "scene": params.scene
  }, {
    _reqLogin: false
  });
}

/***
 * 获取 App/H5 系统功能开关配置
 * @param params
 * @returns {Promise | Promise<unknown>}
 * @private
 */
export function getAppSystemConfig(params = {}) {
  return request.get('/api/v1/rental/common/app/system-config', {
    platform: params.platform,
    channel: params.channel
  }, {
    _reqLogin: false,
    _showLoading: false
  });
}

/**
 * 获取公开门店列表
 */
export function getStores() {
  return request.get('/api/v1/rental/common/stores', {}, {
    _reqLogin: false,
    _showLoading: false
  });
}

/** 获取公开门店详情。 */
export function getStoreDetail(id) {
  return request.get(`/api/v1/rental/common/stores/${id}`, {}, {
    _reqLogin: false,
    _showLoading: false
  });
}

/***
 * 获取协议
 * @param params
 * @returns {Promise | Promise<unknown>}
 * @private
 */
export function getAgreements(params = {}, config = {}) {
  return request.get('/api/v1/rental/common/agreements', {
    "sceneCode": params.sceneCode
  }, {
    ...config,
    _reqLogin: false
  });
}


/***
 * 用户创建配送地址
 * @param params
 * @returns {Promise | Promise<unknown>}
 * @private
 */
export function addAddress(params = {}) {
  return request.post('/api/v1/rental/shipping-addresses', params);
}

/***
 * 获取当前用户的默认配送地址
 * @param params
 * @returns {Promise | Promise<unknown>}
 * @private
 */
export function getDefaultAddress(params = {}) {
  return request.get(`/api/v1/rental/shipping-addresses/default`);
}

/***
 * 将指定地址设置为用户的默认配送地址
 * @param params
 * @returns {Promise | Promise<unknown>}
 * @private
 */
export function setDefaultAddress(params = {}) {
  return request.put(`/api/v1/rental/shipping-addresses/default/${params.id}`);
}

/***
 * 获取当前用户的配送地址列表
 * @param params
 * @returns {Promise | Promise<unknown>}
 * @private
 */
export function getAddressList(params = {}, config = {}) {
  return request.get('/api/v1/rental/shipping-addresses/list', params, config);
}

/**
 * 获取可配送省市区分级数据
 * @param params
 * @param config
 * @returns {Promise | Promise<unknown>}
 * @private
 */
export function getShippingAddressRegions(params = {}, config = {}) {
  return request.get('/api/v1/rental/shipping-addresses/regions', {
    provinceCode: params.provinceCode || '',
    cityCode: params.cityCode || ''
  }, {
    ...config,
    _showLoading: false
  });
}

/***
 * 根据ID获取指定的配送地址信息
 * @param params
 * @returns {Promise | Promise<unknown>}
 * @private
 */
export function getAddressById(params = {}) {
  return request.get(`/api/v1/rental/shipping-addresses/${params.id}`);
}

/***
 * 更新用户的配送地址
 * @param params
 * @returns {Promise | Promise<unknown>}
 * @private
 */
export function updateAddress(params = {}) {
  return request.put(`/api/v1/rental/shipping-addresses/${params.id}`, params);
}



/***
 * 删除指定的配送地址
 * @param params
 * @returns {Promise | Promise<unknown>}
 * @private
 */
export function deleteAddress(params = {}) {
  return request.delete(`/api/v1/rental/shipping-addresses/${params.id}`);
}

/***
 * 获取配送公司列表
 * @param params
 * @returns {Promise | Promise<unknown>}
 * @private
 */
export function queryCarriers() {
  return request.get(`/api/v1/rental/common/carriers`);
}

/***
 * 获取银行列表
 * @param params type: 1=银行/虚拟账户 2=电子钱包
 * @returns {Promise | Promise<unknown>}
 * @private
 */
export function queryBankList(params = {}) {
  return request.get('/api/v1/rental/common/banks', params);
}

/***
 * 获取租机说明
 * @param params keys: rental-terms-en=英文,rental-terms-id=印尼文
 * @returns {Promise | Promise<unknown>}
 * @private
 */
export function getRentalTerms(params = {}) {
  return request.get('/api/v1/rental/common/system-configs', params);
}






